import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import H1 from '@base/H1/H1';
import H3 from '@base/H3/H3';
import Paper from '@base/Paper/Paper';
import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';

const LeadershipPrinciplesPosters1 = 'careers/LeadershipPrinciplesPosters1.png';
const LeadershipPrinciplesPosters2 = 'careers/LeadershipPrinciplesPosters2.png';
const LeadershipPrinciplesPosters3 = 'careers/LeadershipPrinciplesPosters3.png';
const LeadershipPrinciplesPosters4 = 'careers/LeadershipPrinciplesPosters4.png';
const LeadershipPrinciplesPosters5 = 'careers/LeadershipPrinciplesPosters5.png';
const LeadershipPrinciplesPosters6 = 'careers/LeadershipPrinciplesPosters6.png';
const LeadershipPrinciplesPosters7 = 'careers/LeadershipPrinciplesPosters7.png';
const LeadershipPrinciplesPosters8 = 'careers/LeadershipPrinciplesPosters8.png';
const LeadershipPrinciplesPosters9 = 'careers/LeadershipPrinciplesPosters9.png';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: var(--color-i-blue-5);
  padding: ${Spacings.SPACING_0B};
  padding-top: ${Spacings.SPACING_30B};
  padding-bottom: 140px;
  ${mediaQuery.uptoTablet} {
    padding-right: ${Spacings.SPACING_12B};
    padding-left: ${Spacings.SPACING_12B};
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B};
    padding-top: ${Spacings.SPACING_10B};
    padding-bottom: ${Spacings.SPACING_15B};
  }
`;
const DataTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 752px;
  ${mediaQuery.uptoMobile} {
    width: 320px;
  }
`;
const Headline = styled(H1)`
  font-size: 40px;
  text-align: center;
  line-height: 120%;
  margin: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    line-height: 150%;
    font-size: ${Fonts.H4};
  }
`;
const SubText = styled(H3)`
  text-align: center;
  line-height: 150%;
  font-weight: ${Fonts.REGULAR};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

const PostersWrapper = styled.div`
  display: grid;
  margin-top: ${Spacings.SPACING_20B};
  grid-column-gap: ${Spacings.SPACING_20B};
  grid-row-gap: ${Spacings.SPACING_14B};
  grid-template-columns: repeat(6, 1fr);
  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_12B};
    grid-gap: ${Spacings.SPACING_8B};
  }
  ${mediaQuery.uptoMobile} {
    grid-gap: ${Spacings.SPACING_4B};
  }
`;
const PosterDiv = styled.div`
  grid-column: span 2;
  border: ${Spacings.SPACING_3B} solid var(--color-base-fill);
  background: var(--color-base-1);
  padding: ${Spacings.SPACING_5B} ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    border: ${Spacings.SPACING_2B} solid var(--color-base-fill);
    padding: ${Spacings.SPACING_3B} 10px;
    grid-column: span 3;
    &:last-child {
      grid-column: span 6;
      margin: auto;
    }
  }
`;

const LeadershipPrinciplesPostersArray = [
  LeadershipPrinciplesPosters1,
  LeadershipPrinciplesPosters2,
  LeadershipPrinciplesPosters3,
  LeadershipPrinciplesPosters4,
  LeadershipPrinciplesPosters5,
  LeadershipPrinciplesPosters6,
  LeadershipPrinciplesPosters7,
  LeadershipPrinciplesPosters8,
  LeadershipPrinciplesPosters9
];
const LeaderTile = ({ data, index }) => {
  const { isMobile } = useWindowSize();
  return (
    <PosterDiv>
      <Image
        src={data}
        alt={`leadershipPrinciplesPosters-${index}`}
        height={isMobile ? 172 : 298}
        width={isMobile ? 114 : 199}
      />
    </PosterDiv>
  );
};

const PillarsOfLeadership = () => {
  return (
    <Wrapper>
      <DataTitle>
        <Headline as="h2">Pillars of leadership at Unacademy</Headline>
        <SubText>
          Our leadership principles form the crux of everything we do and it is
          these very principles that have helped us create a strong workforce of
          4,000+ young leaders and innovators.
        </SubText>
      </DataTitle>
      <PostersWrapper>
        {LeadershipPrinciplesPostersArray.map((poster, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <LeaderTile data={poster} index={index} key={`poster-${index}`} />
        ))}
      </PostersWrapper>
    </Wrapper>
  );
};

export default PillarsOfLeadership;
